import { createTheme } from '@mui/material/styles';

const FONT_FAMILY = [
  'HelvNeueOrange',
  '"Helvetica Neue"',
  'Helvetica',
  '"Noto Sans"',
  '"Liberation Sans"',
  'Arial',
  'sans-serif',
].join(', ');

export const muiTheme = createTheme({
  typography: {
    fontFamily: FONT_FAMILY,
  },
});
